// E7 (47024, GES-388): item id -> qty_decimals (0|1|2, null = no rule) from GET /items, read once per page load. Returns a function; null while unread / on any failure (no rule applied, the engine still judges).
// W13: an admin change (ItemsSettings > resetItemQtyDecimals) drops the cache and every mounted hook re-reads it, so the new rule applies without a page reload.
import { useEffect, useState } from 'react';
import api from '../services/api';
import { sanitizeQty } from '../components/qtyDecimals.mjs';

let cache = null;
const listeners = new Set();
export function resetItemQtyDecimals() { cache = null; listeners.forEach(fn => fn()); }
export function useItemQtyDecimals() {
  const [map, setMap] = useState(cache);
  const [tick, setTick] = useState(0);
  useEffect(() => { const fn = () => { setMap(null); setTick(n => n + 1); }; listeners.add(fn); return () => { listeners.delete(fn); }; }, []);
  useEffect(() => {
    if (cache) { setMap(cache); return undefined; }
    let live = true;
    Promise.resolve().then(() => api.request('/items')).then(r => {
      if (!Array.isArray(r)) return;   // a failed / odd answer is not cached: the next mount asks again
      cache = new Map(r.filter(i => i && i.qty_decimals != null).map(i => [i.id, i.qty_decimals]));
      if (live) setMap(cache);
    }).catch(() => {});
    return () => { live = false; };
  }, [tick]);
  return (itemId) => (map && itemId != null && map.has(itemId) ? map.get(itemId) : null);
}
// the typing guard every quantity field shares: (typed text, item id) -> text at the item's decimals (no rule = untouched)
export function useQtySanitizer() {
  const decOf = useItemQtyDecimals();
  return (text, itemId) => sanitizeQty(text, decOf(itemId));
}
